import { render, staticRenderFns } from "./ImportModalWelcome.vue?vue&type=template&id=d8a4e314&scoped=true&"
import script from "./ImportModalWelcome.vue?vue&type=script&lang=js&"
export * from "./ImportModalWelcome.vue?vue&type=script&lang=js&"
import style0 from "./ImportModalWelcome.vue?vue&type=style&index=0&id=d8a4e314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a4e314",
  null
  
)

export default component.exports